import { cn } from "@/lib/utils";

// v1.3 Wave 2 — plan lifecycle -> badge visual mapping. Kept as a single
// lookup table so every surface (card, review dialog, completion card)
// renders lifecycle state identically.
const STATUS_META = {
  proposed: {
    label: "Waiting for your approval",
    dot: "bg-[hsl(var(--ai-proposed))]",
    text: "text-[hsl(var(--ai-proposed))]",
    bg: "bg-[hsl(var(--ai-proposed)/0.12)]",
  },
  executing: {
    label: "Executing\u2026",
    dot: "bg-[hsl(var(--ai-approved))]",
    text: "text-[hsl(var(--ai-approved))]",
    bg: "bg-[hsl(var(--ai-approved)/0.12)]",
  },
  executed: {
    label: "Executed",
    dot: "bg-[hsl(var(--ai-executed))]",
    text: "text-[hsl(var(--ai-executed))]",
    bg: "bg-[hsl(var(--ai-executed)/0.12)]",
  },
  rejected: {
    label: "Rejected",
    dot: "bg-[hsl(var(--ai-rejected))]",
    text: "text-muted-foreground",
    bg: "bg-[hsl(var(--ai-rejected)/0.18)]",
  },
  failed: {
    label: "Failed",
    dot: "bg-[hsl(var(--ai-danger))]",
    text: "text-destructive",
    bg: "bg-destructive/10",
  },
};

export const PlanStatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.proposed;
  return (
    <span
      className={cn("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap", meta.bg, meta.text)}
      data-testid="ai-action-plan-status-badge"
      data-status={status}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", meta.dot)} />
      {meta.label}
    </span>
  );
};
